import config from 'services/config'

export const getImgUrlFromCDN = (fileName, mediaTag, hotelId) => {
  const mediaTagRegex = new RegExp(`^c/|a/`)
  const cleanFileName = fileName.replace(mediaTagRegex, '')

  return `${config.inviteMediaBaseUrl}/${hotelId}/${mediaTag}/${cleanFileName}`
}

export const isCampaignImageVisible = mediaUrl => {
  const extension = getExtensionFromUrl(mediaUrl)
  return extension !== 'pdf'
}

export const getExtensionFromUrl = url => {
  if (!url) {
    return ''
  }

  const withoutQuery = url.split('?')[0].split('#')[0]
  const match = withoutQuery.match(/\.(\w+)$/i)

  return match ? match[1].toLowerCase() : ''
}

const isSalesCampaignForSharedMedia = campaign =>
  campaign.kind === 'Sales' &&
  campaign.category !== 'CardAbandonmentOptedIn' &&
  !(typeof campaign.category === 'string' && campaign.category.includes('ConsentRequest'))

const getCampaignMediaUrl = campaign => campaign.messageMediaUrls?.[0] ?? null

/**
 * Resolves the hotel-level sales media attachment.
 * If some campaigns have the same image and others are empty, treat that image
 * as selected and flag needsSync so the UI can push it to every campaign.
 */
export const getSalesCampaignMediaState = campaigns => {
  if (!campaigns) {
    return { mediaUrl: null, needsSync: false }
  }

  const salesCampaigns = campaigns.filter(isSalesCampaignForSharedMedia)

  if (!salesCampaigns.length) {
    return { mediaUrl: null, needsSync: false }
  }

  const mediaUrls = salesCampaigns.map(getCampaignMediaUrl)
  const nonNullUrls = mediaUrls.filter(Boolean)

  if (!nonNullUrls.length) {
    return { mediaUrl: null, needsSync: false }
  }

  const uniqueNonNullUrls = [...new Set(nonNullUrls)]

  if (uniqueNonNullUrls.length !== 1) {
    return { mediaUrl: null, needsSync: false }
  }

  const mediaUrl = uniqueNonNullUrls[0]
  const needsSync = mediaUrls.some(url => url !== mediaUrl)

  return { mediaUrl, needsSync }
}

export const getCommonCampaignMedia = campaigns => {
  const { mediaUrl } = getSalesCampaignMediaState(campaigns)

  return mediaUrl ? [mediaUrl] : []
}
